import React, { useEffect, useState } from "react";

import StudentCardDetailsPopup from "./../../../components/StudentCardDetails/StudentCardDetails";

import "./AppliedClassesStudentCardComponent.css";

export default function AppliedClassesStudentCardComponent({ cardDetails }) {
  const [showPopup, setShowPopup] = useState(false);

  return cardDetails ? (
    <div className={`tutor-student-card-wrapper`}>
      <div className="tutor-student-card-left-content-wrapper">
        <div className={`applied-class-container ${cardDetails.status === "EXPIRED" ? "expired" : ""}`}>
          <div class="applied-class-container-item-1">
            <div className="student-subject-details">
              <div className="tutor-student-card-name">
                <img src="./card-person-icon.svg" alt="card-person-icon" /> {cardDetails.student_name}
              </div>
              <div className="tutor-student-card-subjects">
                <img src="./card-subject-icon.svg" alt="card-subject-icon" /> Subjects : {cardDetails.subjects}
              </div>
              <div className="tutor-student-card-subjects">
                <img src="./card-subject-icon.svg" alt="card-address-icon" /> Level : {cardDetails.level} ,{" "}
                {cardDetails.stream}
              </div>

              <div className="tutor-student-card-subjects">
                <img src="./card-subject-icon.svg" alt="card-address-icon" /> Classes/Week : {cardDetails.days_per_week}
              </div>
              {cardDetails.distance ? (
                <div className="tutor-student-card-subjects">
                  <img src="./card-address-icon.svg" alt="card-address-icon" /> Distance: {cardDetails.distance} Km away
                </div>
              ) : (
                <div className="tutor-student-card-subjects">
                  <img src="./card-address-icon.svg" alt="card-address-icon" /> Distance:{" "}
                </div>
              )}
              {cardDetails.address !== "undefined" && cardDetails.address && (
                <div className="tutor-student-card-subjects">
                  <img src="./card-address-icon.svg" alt="card-address-icon" /> Address :{" "}
                  {cardDetails.address.split(",").map((val, ind, arr) => (ind < 3 ? val : ""))}
                </div>
              )}
              {(cardDetails.address === "undefined" || !cardDetails.address) && (
                <div className="tutor-student-card-subjects">
                  <img src="./card-address-icon.svg" alt="card-address-icon" /> Address {cardDetails.zip}
                </div>
              )}
            </div>
          </div>
          <div class="item-2">
            <div
              className={`applied-class-container contact-info ${cardDetails.status === "EXPIRED" ? "expired" : ""}`}
            >
              <div
                class="applied-class-container-item-1"
                style={{
                  width: "50%",
                }}
              >
                {(cardDetails.card_domain === "DEMO_CLASSES" || cardDetails.card_domain === "MY_CLASSES") && (
                  <div className="tutor-student-card-right-content-wrapper">
                    <div className="tutor-student-card-right-content-1">
                      <div className="contact-info-text">Call Student</div>

                      <div className="tutor-myclasses-call-to-action-icon">
                        {(cardDetails.status === "ASSIGNED" ||
                          cardDetails.status === "DEMO_SCHEDULED" ||
                          cardDetails.card_domain === "MY_CLASSES") &&
                        cardDetails.phone ? (
                          <a href={`tel:${cardDetails.phone}`}>
                            <img src="./phone-dial-icon.svg" alt="call-to-action-icon" />
                          </a>
                        ) : (
                          <a>
                            <img src="./phone-dial-icon-disabled.svg" alt="call-to-action-icon" />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                class="item-2"
                style={{
                  width: "50%",
                }}
              >
                {(cardDetails.card_domain === "DEMO_CLASSES" || cardDetails.card_domain === "MY_CLASSES") && (
                  <div className="tutor-student-card-right-content-wrapper">
                    <div className="tutor-student-card-right-content-1">
                      <div className="contact-info-text">View Location</div>

                      <div className="tutor-myclasses-call-to-action-icon">
                        {cardDetails.location && cardDetails.status !== "NOT_INTERESTED" ? (
                          <a href={cardDetails.location} target="_blank" rel="noreferrer">
                            <img src="./location.svg" alt="call-to-action-icon" />
                          </a>
                        ) : (
                          <a>
                            <img src="./location-disabled.svg" alt="call-to-action-icon" />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {cardDetails.amount ? (
              <div className="tutor-student-card-right-content-2">
                <div
                  className="tutor-student-card-right-content-2--btn tutor-forms-next-btn-amount"
                  style={{
                    fontSize: "14px",
                    color: "black",
                    "background-color": "rgba(254, 203, 80, 1)",
                    "font-weight": "500",
                    borderRadius: "25px",
                  }}
                >
                  ₹ {cardDetails.amount}/Month
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>

        <div class="applied-class-container">
          <div class="applied-class-container-item-1">
            <div
              style={{ display: "none" }}
              className={`view-details-btn ${cardDetails.status === "EXPIRED" ? "expired" : ""}`}
              onClick={() => {
                console.log("view details button clicked");
                setShowPopup(true);
              }}
            >
              View Details
            </div>
            {showPopup && (
              <StudentCardDetailsPopup cardId={cardDetails.dealings_id} onClose={() => setShowPopup(false)} />
            )}
          </div>
          <div class="item-2">
            {cardDetails.card_domain === "RECOMMENDATION" && (
              <div style={{ display: "none" }} className="tutor-student-card-right-content-2">
                <div className={`tutor-student-card-right-content-2--btn tutor-forms-next-btn yellow-applied-btn`}>
                  Applied
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
